export const errorHandel = (errCode) => {
  const errMess = errCode.split("/")[1].replaceAll("-", " ");
  const newErrMess = errMess[0].toUpperCase().concat(errMess.slice(1));
  return newErrMess;
};
